import { createApi } from "@reduxjs/toolkit/query/react";
import customBaseQuery from "../../../../utils/customBaseQuery";

interface ResponseType {
  type?: number;
  cname: string;
  dlevel: string;
  mname: string;
}

export interface ValidateAnswersType {
  question: string;
  options: string[];
  code: string;
  user_ans: string;
}

export const LearningAssistanceApi = createApi({
  reducerPath: "learningAssistanceApi",
  baseQuery: customBaseQuery,
  endpoints: (builder) => ({
    getGenQa: builder.query({
      query: (questionObject: ResponseType) => ({
        url: "/genqa",
        body: questionObject,
        method: "POST"
      }),
      extraOptions: { service: "Learning_Assistance" }
    }),
    getRealWorld: builder.query({
      query: (response: ResponseType) => ({
        url: "/rlworld",
        body: response,
        method: "POST"
      }),
      extraOptions: { service: "Learning_Assistance" }
    }),
    getPracEdge: builder.query({
      query: (response: ResponseType) => ({
        url: "/prac_edge",
        body: response,
        method: "POST"
      }),
      extraOptions: { service: "Learning_Assistance" }
    }),
    getValidateAnswers: builder.query({
      query: (answer: ValidateAnswersType) => ({
        url: "/val_ans",
        body: answer,
        method: "POST"
      }),
      extraOptions: { service: "Learning_Assistance" }
    })
  })
});

export const {
  useLazyGetGenQaQuery,
  useLazyGetValidateAnswersQuery,
  useGetValidateAnswersQuery,
  useLazyGetRealWorldQuery,
  useLazyGetPracEdgeQuery
} = LearningAssistanceApi;
